import { MeasureUnitConfig } from './MeasureUnitConfig';

export class MeasureUnitUtil {
  public static calcUnitConfig(refValue: number, stepValue?: number): MeasureUnitConfig {
    const config = new MeasureUnitConfig();
    config.refValue = Math.abs(refValue);

    if (!stepValue) {
      return config;
    }

    if (config.refValue < 1) {
      config.decimalPlaces = 2;
    } else if (config.refValue < 1000) {
      if (stepValue < 1) {
        config.decimalPlaces = 2;
      } else {
        config.decimalPlaces = 0;
      }
    } else if (config.refValue < 1000000) {
      if (stepValue < 1) {
        config.decimalPlaces = 2;
      } else if (stepValue <= 9) {
        config.decimalPlaces = 0;
      } else if (stepValue <= 99) {
        config.decimalPlaces = 2;
        config.shortenThousands = true;
      } else if (stepValue <= 999) {
        config.decimalPlaces = 1;
        config.shortenThousands = true;
      } else {
        config.decimalPlaces = 0;
        config.shortenThousands = true;
      }
    } else if (stepValue < 1) {
      config.decimalPlaces = 2;
    } else if (stepValue <= 999) {
      config.decimalPlaces = 0;
    } else if (stepValue <= 9999) {
      config.decimalPlaces = 3;
    } else if (stepValue <= 99999) {
      config.decimalPlaces = 2;
    } else if (stepValue <= 999999) {
      config.decimalPlaces = 1;
    } else {
      config.decimalPlaces = 0;
    }

    return config;
  }
}
